<template>
  <el-dialog v-loading="loading" title="划价单退款" :visible.sync="dialogRefund" :before-close="close" width="500px"
    :close-on-click-modal="false">
    <div class="price">￥{{ totalRefundAmount }}</div>
    <div class="residuePrice">剩余退款金额￥{{ surplusRefundAmount }}</div>
    <el-radio-group v-model="refundWay">
      <el-radio label="1">原路返回</el-radio>
      <el-radio label="2">直接退现金</el-radio>
    </el-radio-group>
    <div class="detail-warp">
      <div class="detail-tittle">
        <div class="width-warp">支付明细</div>
        <div class="width-warp">剩余退款金额</div>
        <div class="width-warp">退款方式</div>
      </div>
      <div v-for="item in payList" :key="item.id">
        <div class="detail-list">
          <div class="width-warp">{{ item.payWay | filterPayWay(that) }}：¥{{ item.payPrice }}</div>
          <div class="width-warp">¥{{ item.surplusRefundAmount }}</div>
          <div class="width-warp" v-if="refundWay == '1'">
            <!-- <el-select v-model="item.payWay" placeholder="">
              <el-option label="现金" value="2">
              </el-option>
            </el-select> -->
            原路退还
          </div>
          <div class='width-warp' v-else>现金</div>
        </div>
        <div class="tips" v-if="item.tips">提示：当前支付方式不可原路退还，需选择其他退款方式</div>
      </div>
    </div>
    <div class="remark">
      <el-input placeholder="请输入备注" v-model="remark">
        <template slot="prepend">退款备注</template>
      </el-input>
    </div>
    <div class="refund-detail" v-if="refundList.length > 0">
      <div>实际退款明细：</div>
      <div style="margin-top:8px" v-for="item in refundList" :key="item.id">
        <span class="span-warp">{{ item.refundWay | filterPayWay(that) }}:</span>
        <span class="span-warp">{{ item.refundAmount }}元</span>
        <span class="span-warp">({{ item.refundTime }})</span>
      </div>
    </div>
    <div class="btns-warp">
      <el-button @click="close">取 消</el-button>
      <el-button @click="isRefund" type="danger">退款</el-button>
    </div>
  </el-dialog>
</template>

<script  lang="js">
import { getOrderRecord, refund, getRefundRecord, refundOrderPayment } from '@/api/pricingDetails'
import { isNull } from '@/utils/validateBase'
import { Utils } from '@/utils/utils'
import { cancelSettlement } from '@/utils/yibaoTools'
import { CommonDTO } from '@/DTO/index'
export default {
  data() {
    return {
      that: this,
      payList: [],//支付记录
      refundList: [],//退款记录
      PAY_WAY: [],//付款方式常量
      totalRefundAmount: '0.00',//退款总金额
      surplusRefundAmount: '0.00',//剩余总金额
      refundWay: '1',//退款方式
      remark: '',//备注
      loading: false
    }
  },
  props: {
    dialogRefund: Boolean,
    orderNumber: String | Number,
    orderId: String | Number,
  }, // 接收父组件传递的参数
  async created() {
    this.PAY_WAY = await CommonDTO.getPayWay()
    this.getOrderRecord()
    this.getRefundRecord()
  },
  filters: {
    filterPayWay(val, _this) {
      let str = ''
      if (!isNull(val)) {
        _this.PAY_WAY.forEach(item => {
          if (item.value == val) {
            str = item.label
          }
        })
      }
      return str
    }
  },
  methods: {
    // 退款
    isRefund() {
      // if (Utils.gt(this.surplusRefundAmount, 0)) {
      let msg = '';
      let arr = []
      if (this.refundWay == '2') msg = '点击继续退款，直接退现金给患者';
      else msg = '点击继续退款，线上微信支付金额将原路退回；社保退款请在调起医保控件时刷医保卡退款，剩余金额请退现金给患者！';
      this.$confirm(msg).then(_ => {
        this.loading = true;
        let refundList = this.payList.filter(item => {
          return item.refundAll != '1'    //过滤已经退款成功的数据
        })
        refundList.forEach(item => {
          let preParams = {
            refundWay: this.refundWay == '2' ? '2' : item.payWay,
            orderPayNumber: item.orderPayNumber,
            payPalNumber: item.payPalNumber,
            refundAmount: item.payPrice,
            deptId: this.$session.get('deptId'),
          }
          let params = {
            orderNumber: this.orderNumber,
            orderPayNumber: item.orderPayNumber,
            payPalNumber: item.payPalNumber,
            refundWay: this.refundWay == '2' ? '2' : item.payWay,
            refundAmount: item.payPrice,
            remark: this.remark,
            deptId: this.$session.get('deptId'),
          }
          if (item.payWay == '1') {
            // 存在医保支付
            params.attach = JSON.parse(item.attach)
            let res = cancelSettlement(preParams, params, this)
            arr.push(res)
          } else {
            let res = this.refund(preParams, params)
            arr.push(res)
          }
        })
        Promise.all(arr).then(res => {
          // 退款提交订单
          this.refundOrderPayment()
        }).catch(res => {
        })
      }).catch(_ => {
      });
      // } else {
      //   // 退款提交订单
      //   this.refundOrderPayment()
      // }
    },
    // 退款
    refund(preParams, params) {
      return new Promise((resolve, reject) => {
        payDTO.refundFun(preParams, params).then(res => {
          if (res.code == 200) {
            resolve(res)
          } else {
            this.getRefundRecord()
            this.loading = false
          }
        })
        // payDTO.preRefund(params).then(res=>{
        //   console.log(res,888888);
        // })
        // refund(params).then(res => {
        //   if (res.code == 200) {
        //     resolve(res)
        //   } else {
        //     this.getRefundRecord()
        //   }
        // })
      })
    },
    /**
     * 查询退款记录
     */
    getRefundRecord() {
      getRefundRecord({ orderNumber: this.orderNumber }).then(res => {
        let { code, data } = res
        if (code == 200) {
          let arr = data.filter(item => {
            return item.refundSuccess == '1'
          })
          this.refundList = arr
        }
      })
    },
    // 关闭弹框
    close() {
      this.$emit('dialogRefundBack', false);
    },
    /**
      * 获取支付记录
     */
    getOrderRecord() {
      getOrderRecord({ orderNumber: this.orderNumber }).then(res => {
        let { code, data } = res
        if (code == 200) {
          this.totalRefundAmount = data.totalRefundAmount
          this.surplusRefundAmount = data.surplusRefundAmount
          data.recordItem.forEach(item => {
            // 判断是否跨月
            // if (item.payWay == '1' && Utils.judgeMonth(item.payTime)) {
            //   item.payWay = '2'
            //   item.tips = true
            // }
          })
          this.payList = data.recordItem
        }
      })
    },
    /**
     * 完成退款
     */
    refundOrderPayment() {
      refundOrderPayment({ orderId: this.orderId, orderNumber: this.orderNumber }).then(res => {
        if (res.code == 200) {
          this.$message.success('退款成功！')
          this.loading = false
          this.close()
        } else {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.residuePrice {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 30px;
}

.width-warp {
  width: 400px;
  text-align: left;
}

.detail-warp {
  margin-top: 30px;

  .detail-tittle {
    display: flex;
  }

  .detail-list {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .residuePrice-warp {
      width: 100px;
      text-align: left;
    }
  }

  .tips {
    font-size: 12px;
    margin-top: 8px;
  }
}

.remark {
  margin-top: 20px;
  width: 300px;

  .el-input {
    width: 100% !important;
  }
}

.refund-detail {
  margin-top: 20px;

  .span-warp {
    margin-right: 10px;
  }
}

.btns-warp {
  margin-top: 20px;
  text-align: right;
}

.el-select {
  width: 80px;

  /deep/.el-input {
    width: 80px !important;
  }

  /deep/.el-input__inner {
    width: 80px;
    padding: 0;
    font-size: 14px;
    padding-left: 8px;
  }

}
</style>